import React, { useState } from 'react'

// Material-UI
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import './PetsSection.scss'
import { useErrorSnackBarContext } from '../../ErrorSnackBar/ErrorSnackBarContext'
import Interceptor from '../../../../Services/serviceBase.interceptor'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import PetsItem from "./PetsItem"

function PetsSection({ residentialplansEntity }) {
  const { errorSnackBarActions } = useErrorSnackBarContext()
  Interceptor.interceptor(errorSnackBarActions)
  const [value, setValue] = useState(0)
  let indoorPets = []
  let outdoorPets = []

  if (residentialplansEntity.pets && residentialplansEntity.pets.length > 0) {
    residentialplansEntity.pets.map(item => {
      if (item.zoneType === 1) {
        return indoorPets.push(item)
      } else if (item.zoneType === 2) {
        return outdoorPets.push(item)
      } else {
        return null
      }
    })
  }

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const handleTabChange = (event, newValue) => {
    setValue(newValue)
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <div className="section-content">
            {children}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="App Pets">
      <h2>Pet or Service Animal?</h2>
      <Container maxWidth="lg">
        <Grid container spacing={1}>
          <Grid size={12}>
          </Grid>
          <Grid size={12}>
            <form noValidate autoComplete="off">
              <Grid container>
                <Grid size={12}>
                  <Grid container>
                    <Grid size={6} className="container-field">
                      {residentialplansEntity.petIds && residentialplansEntity.petIds.indoorPets ?
                        <label>Number of indoor pets or service animals: <b>{residentialplansEntity.petIds ? residentialplansEntity.petIds.indoorPets : '0'}</b></label>
                        : null}
                    </Grid>
                    <Grid size={6} className="container-field">
                      {residentialplansEntity.petIds && residentialplansEntity.petIds.outdoorPets ?
                        <label>Number of outdoor pets or service animals: <b>{residentialplansEntity.petIds ? residentialplansEntity.petIds.outdoorPets : '0'}</b></label>
                        : null}
                    </Grid>
                  </Grid> <br />
                  {residentialplansEntity.pets && residentialplansEntity.pets.length > 0 ? (
                    <Grid  className="container-field">
                      <AppBar elevation={0} position="static" className="header">
                        <Tabs variant="fullWidth" border={0} centered={true} className="detail-tabs-container" value={value} onChange={handleTabChange} aria-label="simple tabs example">
                          {indoorPets && indoorPets.length > 0 ?
                            <Tab className="detail-tab" label="Indoor Pets" {...a11yProps(0)} />
                            : null}
                          {outdoorPets && outdoorPets.length > 0 ?
                            <Tab className="detail-tab" label="Outdoor Pets" {...a11yProps(indoorPets.length === 0 ? 0 : 1)} />
                            : null}
                        </Tabs>
                      </AppBar>
                      <div className="sticky-container">
                      {indoorPets && indoorPets.length > 0 ?
                        <TabPanel className="detail-tab section-content" value={value} index={0}>
                          {indoorPets.map((item, index) => {
                            return <Grid>
                              <h3>Indoor Pet # {index + 1} </h3> <br />
                              <PetsItem key={item._id} petsEntity={item} />
                            </Grid>
                          })}
                        </TabPanel>
                        : null}

                      {outdoorPets && outdoorPets.length > 0 ?
                        <TabPanel className="detail-tab section-content" value={value} index={indoorPets.length === 0 ? 0 : 1}>
                          {outdoorPets.map((item, index) => {
                            return <Grid>
                              <h3>Outdoor Pet # {index + 1} </h3> <br />
                              <PetsItem key={item._id} petsEntity={item} />
                            </Grid>
                          })}
                        </TabPanel>
                        : null}
                      </div>
                    </Grid>
                  ) : null}
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Container>
    </div >
  )
}

export default PetsSection
